export interface PeriodStats {
  count: number;
  previousCount: number;
  percentageChange: number;
}

export interface TestCountAnalytics {
  week?: PeriodStats;
  month?: PeriodStats;
  quarter?: PeriodStats;
  year?: PeriodStats;
  range?: PeriodStats;
  all?: PeriodStats;
}

export interface OrgTestCountAnalytics extends TestCountAnalytics {
  orgId: string;
  orgName: string;
}

export interface DistributorSaleObject {
  date: string;
  devicesSold: number;
  newAccounts: number;
}
export interface DistributorSalesData {
  weekly: DistributorSaleObject[];
  monthly: DistributorSaleObject[];
  quarterly: DistributorSaleObject[];
  yearly: DistributorSaleObject[];
}

export interface CategoryCount {
  category: string;
  count: number;
}

export interface DeviceCount {
  device: string;
  count: number;
}

export interface OrgBreakdown {
  devices: DeviceCount[];
  categories: CategoryCount[];
}

export interface DemoAccount {
  orgId: string;
  orgName: string;
  distId: string;
  accountType: string[];
  demoTests: number;
}

export interface DemoTestTotals {
  demoTests: number;
  totalTests: number;
  demoAccounts: number;
  accounts: DemoAccount[];
}

export interface MultiAccountDevice {
  serialNo: string;
  accounts: { orgId: string; orgName: string; alias?: string }[];
}

export interface MultiAccountDevices {
  count: number;
  devices: MultiAccountDevice[];
}

export interface DistributorDemoStats {
  distId: string;
  demoAccounts: number;
  demoCount: number;
  monthlyAverage: number | null;
  yearlyAverage: number | null;
}

export interface DistributorComparison {
  period: { start: string; end: string; months: number; years: number };
  includedDistributors: number;
  totalDistributors: number;
  distributors: DistributorDemoStats[];
}

export const ALL_DISTRIBUTORS_ID = "all";

export interface DistributorWithCountry {
  distId: string;
  country: string;
}

export type AnalyticsDateRange = [Date | null, Date | null];

export enum TimePeriod {
  WEEK = "week",
  MONTH = "month",
  QUARTER = "quarter",
  YEAR = "year",
  RANGE = "range",
  ALL = "all",
}

export enum SalesMetric {
  ACCOUNTS = "newAccounts",
  DEVICES = "devicesSold",
}
